<div class="main-page-section default_font pt-3 pt-md-4 px-3 px-md-4 px-lg-5 d-flex flex-column">
    <div class="flex-fill">
        <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
            <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/list-survey">List Polls / Survey</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev">Survey Details</span>
        </div>

        <div class="align-items-center justify-content-between mb-3 mb-md-4">
            <h2 class="font-weight-bold mb-3 mb-md-4">Survey Response Summary</h2>
            <h4 class="text-primary font-weight-semibold">Survey Name: {{surveyDetails?.data.surveyName}}</h4>
        </div>

        <h6 class="font-weight-light h5 mb-3 mb-md-4">Survey Attributes</h6>
        <div class="row row-gap-4 mb-4 mb-md-5">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Park Name</small>
                <span class="font-weight-medium text-gray-dark">{{surveyDetails?.data.parkName}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Survey Start Date</small>
                <span
                    class="font-weight-medium text-gray-dark">{{formatDateAll(surveyDetails?.data.surveyStartDate,'date')}}</span>
            </div>
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">SurveyEnd Date</small>
                <span
                    class="font-weight-medium text-gray-dark">{{formatDateAll(surveyDetails?.data.surveyEndDate,'date')}}</span>
            </div>
            <!-- <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column row-gap-2">
                <small class="font-weight-light text-gray-medium">Coupon Assinged</small>
                <span class="font-weight-medium text-gray-dark">{{surveyDetails?.data.couponTitle}}</span>
            </div> -->
        </div>
    </div>
    <div class="mb-4 mb-md-5 pb-4 pb-md-5 border-bottom" *ngIf="surveyEdit">
        <button class="btn btn-primary" (click)="gotoEditPage(surveyId)">Edit</button>
    </div>

    <div *ngIf="!showPreview">
        <form [formGroup]="surveyForm" (ngSubmit)="onSubmit()">
            <div formArrayName="questions" class="mb-3 mb-md-4">
                <div class="d-flex flex-column row-gap-4">
                    <div *ngFor="let question of questionsArray; let i = index" [formGroupName]="i">
                        <div class="bg-lighter border border-light rounded p-3 p-md-4 position-relative">
                            <h4 class="font-weight-semibold mb-2 mb-md-3">Question {{ i + 1 }}</h4>
                            <div class="row row-gap-4">
                                <div class="d-flex flex-column row-gap-1 col-12 col-md-6 col-lg-8">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <input type="text" formControlName="questionText" id="questionText"
                                            class="form-control" placeholder="Write your question">
                                        <label>Write your question</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="question.get('questionText').invalid && question.get('questionText').touched"
                                            class="small text-danger">
                                            <div *ngIf="question.get('questionText').errors?.required">
                                                Question is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column row-gap-1 col-12 col-md-6 col-lg-4">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <select class="form-control" formControlName="questionType"
                                            (change)="clearAnswer(question,i)">
                                            <option value="">Select question type</option>
                                            <option value="{{qtype.questionType}}" *ngFor="let qtype of questionTypes">
                                                {{qtype.questionName}}
                                            </option>
                                        </select>
                                        <label>Your Question Type</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="question.get('questionType').invalid && question.get('questionType').touched"
                                            class="small text-danger">
                                            <div *ngIf="question.get('questionType').errors?.required">
                                                Question Type is required.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 d-flex flex-column row-gap-2"
                                    *ngIf="question.get('questionType').value !== ''">
                                    <div class="row mx-0 w-100 row-gap-3" formArrayName="answers">
                                        <div class="col-12 px-0"
                                            *ngFor="let option of question.get('answers').controls; let j = index"
                                            [formGroupName]="j">
                                            <div class="form-row">
                                                <div class="col-12 col-md-6 col-lg-10 d-flex column-gap-3">
                                                    <span *ngIf="question.get('questionType').value === '1'"
                                                        class="text-primary font-weight-bold flex-shrink-0 pt-3">Radio
                                                        Button
                                                        {{j + 1}}</span>
                                                    <span *ngIf="question.get('questionType').value === '3'"
                                                        class="text-primary font-weight-bold flex-shrink-0 pt-3">Checkbox
                                                        Option
                                                        {{j + 1}}</span>
                                                    <div class="d-flex flex-column row-gap-1 w-100"
                                                        *ngIf="question.get('questionType').value != '2'">
                                                        <div class="form-group floating_form_field mb-0 w-100">
                                                            <input type="text" formControlName="answerText"
                                                                class="form-control"
                                                                [placeholder]="question.get('questionType').value === '2' ? 'Write your answer' : 'Enter Charecter length'">
                                                            <label
                                                                *ngIf="question.get('questionType').value === '1' || question.get('questionType').value === '3'">Write
                                                                your answer</label>
                                                        </div>
                                                        <div class="d-flex justify-content-between">
                                                            <div *ngIf="option.get('answerText').invalid && option.get('answerText').touched"
                                                                class="small text-danger">
                                                                <div *ngIf="option.get('answerText').errors?.required">
                                                                    Answer is required.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex flex-column row-gap-3">
                                                        <span *ngIf="question.get('questionType').value === '2'"
                                                            class="text-primary font-weight-bold flex-shrink-0 pt-3">Set
                                                            Charecter Limit</span>
                                                        <div class="d-flex flex-wrap row-gap-1 w-100 column-gap-3"
                                                            *ngIf="question.get('questionType').value === '2'">
                                                            <div class="custom-control custom-radio flex-shrink-0">
                                                                <input type="radio" formControlName="answerText"
                                                                    id="r50{{i}}" value="50"
                                                                    class="custom-control-input">
                                                                <label for="r50{{i}}"
                                                                    class="custom-control-label cursor-pointer">50</label>
                                                            </div>
                                                            <div class="custom-control custom-radio flex-shrink-0">
                                                                <input type="radio" formControlName="answerText"
                                                                    id="r100{{i}}" value="100"
                                                                    class="custom-control-input">
                                                                <label for="r100{{i}}"
                                                                    class="custom-control-label cursor-pointer">100</label>
                                                            </div>
                                                            <div class="custom-control custom-radio flex-shrink-0">
                                                                <input type="radio" formControlName="answerText"
                                                                    id="r150{{i}}" value="150"
                                                                    class="custom-control-input">
                                                                <label for="r150{{i}}"
                                                                    class="custom-control-label cursor-pointer">150</label>
                                                            </div>
                                                            <div class="custom-control custom-radio flex-shrink-0">
                                                                <input type="radio" formControlName="answerText"
                                                                    id="r200{{i}}" value="200"
                                                                    class="custom-control-input">
                                                                <label for="r200{{i}}"
                                                                    class="custom-control-label cursor-pointer">200</label>
                                                            </div>
                                                            <div class="d-flex justify-content-between">
                                                                <div *ngIf="option.get('answerText').invalid && option.get('answerText').touched"
                                                                    class="small text-danger">
                                                                    <div
                                                                        *ngIf="option.get('answerText').errors?.required">
                                                                        Answer is required.
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-lg-2 pt-3">
                                                    <button *ngIf="j!==0" (click)="removeAnswer(question, j)"
                                                        class="btn btn-danger row_remove">
                                                        <svg-icon
                                                            src="../../../assets/images/icons/close.svg"></svg-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="question.get('questionType').value != '2'">
                                        <span class="text-dark font-weight-bold cursor-pointer"
                                            (click)="addAnswer(question)">+
                                            Add another</span>
                                    </div>
                                </div>
                            </div>
                            <button *ngIf="i!==0" (click)="removeQuestion(i)" class="btn btn-danger card_remove">
                                <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="pt-3 pt-md-4 border-top border-muted mt-3 mt-md-4">
                    <span class="text-primary font-weight-bold cursor-pointer" (click)="addQuestion()">+ Add another
                        question</span>
                </div>
                <div
                    class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
                    <button class="btn btn-primary" type="submit">Preview</button>
                </div>
            </div>
        </form>
    </div>
    <div>
        <div class="d-flex flex-column" *ngIf="showPreview">
            <div *ngFor="let question of arrayForPreview; let i=index" class="question_set w-100">
                <h3 class="h4 font-weight-semibold mb-3 mb-md-4">Question {{ question.QuestionSerial }}</h3>
                <p class="h5 font-weight-normal mb-3">{{ question.surveyQuestion }}</p>
                <div class="d-flex column-gap-4 row-gap-4 flex-wrap">
                    <ng-container *ngFor="let response of question.responses; let j=index;">
                        <ng-container *ngIf="question.answerType==1">
                            <div class="custom-control custom-radio flex-shrink-0 pointer-event-none">
                                <input type="radio" id="r{{j+1}}" value="{{ response.answerText }}"
                                    class="custom-control-input">
                                <label for="r{{h+1}}" class="custom-control-label cursor-pointer">{{ response.answerText
                                    }}</label>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="question.answerType==3">
                            <div class="custom-control custom-checkbox flex-shrink-0 pointer-event-none">
                                <input type="checkbox" id="r{{j+1}}" value="{{ response.answerText }}"
                                    class="custom-control-input">
                                <label for="r{{h+1}}" class="custom-control-label cursor-pointer">{{ response.answerText
                                    }}</label>
                            </div>
                        </ng-container>
                        <div class="d-flex flex-column row-gap-1 col-12 col-md-8 px-0" *ngIf="question.answerType==2">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <textarea id="r{{j+1}}" class="form-control pointer-event-none"
                                    placeholder="Write here"></textarea>
                                <label>Write here</label>
                            </div>
                            <div class="small">Charecter Limit: {{ response.answerText }}</div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div
                class="py-3 py-md-4 mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
                <!-- <button class="btn btn-clear text-danger" (click)="openModal(surveyId)">Remove</button> -->
                <button class="btn font-weight-bold small mb-0 cursor-pointer remove-button-color"
                    (click)="forceEdit()">Edit</button>
                <button class="btn btn-primary" (click)="submitFinalData(finalSubmissionArray)">Send</button>
            </div>
        </div>

        <div class="d-flex flex-column" *ngIf="arrayForPreviewPreAdded.length>0">
            <div *ngFor="let question of arrayForPreviewPreAdded; let i=index" class="question_set w-100">
                <h3 class="h4 font-weight-semibold mb-3 mb-md-4">Question {{ question.questionSerial}}</h3>
                <p class="h5 font-weight-normal mb-3">{{ question.surveyQuestion }}</p>
                <div class="d-flex column-gap-4 row-gap-4 flex-wrap">
                    <ng-container *ngFor="let response of question.responses; let j=index;">
                        <ng-container *ngIf="question.answerType==1">
                            <div class="custom-control custom-radio flex-shrink-0 pointer-event-none">
                                <input type="radio" id="r{{j+1}}" value="{{ response.responseText }}"
                                    class="custom-control-input">
                                <label for="r{{h+1}}" class="custom-control-label">{{response.responseText}}</label>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="question.answerType==3">
                            <div class="custom-control custom-checkbox flex-shrink-0 pointer-event-none">
                                <input type="checkbox" id="r{{j+1}}" value="{{ response.responseText }}"
                                    class="custom-control-input">
                                <label for="r{{h+1}}" class="custom-control-label">{{response.responseText}}</label>
                            </div>
                        </ng-container>
                        <div class="d-flex flex-column row-gap-1 col-12 col-md-8 px-0" *ngIf="question.answerType==2">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <textarea id="r{{j+1}}" class="form-control pointer-event-none"
                                    placeholder="Write here"></textarea>
                                <label>Write here</label>
                            </div>
                            <div class="small">Charecter Limit: {{ response.responseText }}</div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="showPreviewFromApi && arrayForPreviewPreAdded.length > 0 && surveyCreate"
                class="py-3 py-md-4 mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
                <!-- <button class="btn btn-clear text-danger" (click)="openModal(surveyId)">Remove</button> -->
                <button class="btn btn-clear text-dark" (click)="goToEditPageQuestion(surveyId)">Edit</button>
                <button class="btn btn-primary" (click)="goToSurveyReport(surveyId)">Send</button>
            </div>
        </div>
    </div>
</div>